import { useTranslation } from "react-i18next";
import { Col, Input, InputGroup, InputGroupText, Label, Row } from "reactstrap";
import BenefitsEditor from "../../../components/Benefits/BenefitsEditor";
import { useSettings } from "../../../../../context/settings";

function PayrollTab({ employeeData, setEmployeeData }) {
  const { t } = useTranslation();
  const { settings } = useSettings();

  return(
    <>
      <Row>
        <Col md="6" className="mb-3">
          <Label>{t('hr.monthlySalary')} </Label>
          <InputGroup>
            <InputGroupText>{settings?.sales?.base_currency || ''}</InputGroupText>
            <Input
              type="number"
              value={employeeData.salary_amount || ''}
              onChange={(e) => setEmployeeData({ ...employeeData, salary_amount: e.target.value })}
            />
          </InputGroup>
        </Col>
        <Col md="6" className="mb-3">
          <Label>{t('sales.paymentMethod')} </Label>
          <Input type="select" value={employeeData.payment_method || ''} onChange={(e) => setEmployeeData({ ...employeeData, payment_method: e.target.value })}>
            <option value="bank">{t('sales.bankTransfer')}</option>
            <option value="cash">{t('sales.cash')}</option>
            <option value="cheque">{t('sales.cheque')}</option>
          </Input>
        </Col>
      </Row>

      <hr />

      <BenefitsEditor employeeData={employeeData} setEmployeeData={setEmployeeData} />

      <hr />

      <h5 className="fw-bold mt-4">{t('sales.bankDetails')}</h5>
      <Row>
        <Col md="6" className="mb-3">
          <Label>{t('sales.bankName')} </Label>
          <Input 
            type="text" 
            value={employeeData.bank_name || ''} 
            onChange={(e) => setEmployeeData({ ...employeeData, bank_name: e.target.value })} 
          />
        </Col>
        <Col md="6" className="mb-3">
          <Label>{t('sales.accountNumber')} </Label>
          <Input 
            type="text" 
            value={employeeData.bank_account_number || ''} 
            onChange={(e) => setEmployeeData({ ...employeeData, bank_account_number: e.target.value })} 
          />
        </Col>
        <Col md="6" className="mb-3">
          <Label>{t('sales.routingIban')} </Label>
          <Input 
            type="text" 
            value={employeeData.bank_routing_iban || ''} 
            onChange={(e) => setEmployeeData({ ...employeeData, bank_routing_iban: e.target.value })} 
          />
        </Col>
      </Row>

      <hr />

      <h5 className="fw-bold mt-4">{t('hr.social')}</h5>
      <Row>
        <Col md="6" className="mb-3">
          <Label>{t('hr.socialSecurityNumber')} </Label>
          <Input 
            type="text" 
            value={employeeData.social_security_number || ''} 
            onChange={(e) => setEmployeeData({ ...employeeData, social_security_number: e.target.value })} 
          />
        </Col>
      </Row>
    </>
  );
}

export default PayrollTab;
